import { takeLatest, call, put, delay } from 'redux-saga/effects';
import * as actions from '../actions';
import * as api from '../../api';
import fetchHomePageDataSaga from './fetch-homepage-data';
import searchPostsSaga from './search-posts';

function* fetchLatestPostSaga(action) {
    try {
        yield put(actions.showLoading());
        const posts = yield call(api.fetchPosts, action.payload);
        // console.log('[posts]', posts);
        yield put(actions.getLatestPosts.getPostSuccess(posts.data.data));
        yield put(actions.hideLoading());
    } catch (error) {
        console.log(error);
        yield put(actions.getLatestPosts.getPostFailure(error));
        yield put(actions.hideLoading());
    }
}

function* fetchHighLightPostsSaga(action) {
    try {
        yield put(actions.showLoading());
        const posts = yield call(api.getHighLightPosts);
        // console.log('[fetchHighLightPostsSaga]', posts);
        yield put(actions.getHighLightPosts.getSuccess(posts.data.data));
        yield put(actions.hideLoading());
    } catch (error) {
        console.log(error);
        yield put(actions.getHighLightPosts.getFailure(error));
        yield put(actions.hideLoading());
    }
}

function* fetchRelatedPostsSaga(action) {
    try {
        yield put(actions.showLoading());
        const posts = yield call(api.getRelatedPosts, action.payload);
        // console.log('[fetchRelatedPostsSaga]', posts);
        yield put(actions.getRelatedPosts.getRelatedPostsSuccess(posts.data));
        yield put(actions.hideLoading());
    } catch (error) {
        console.log(error);
        yield put(actions.getRelatedPosts.getRelatedPostsFailure(error));
        yield put(actions.hideLoading());
    }
}

function* fetchPostDetailSaga(action) {
    try {
        yield put(actions.showLoading());

        if (typeof (action.payload) === 'object') {
            const posts = yield call(api.getPostDetail, action.payload.id);
            // console.log('[fetchPostDetailSaga]', posts);
            yield put(actions.getPostDetail.getPostDetailSuccess({
                detail: posts.data.data,
                latest: [],
                related: []
            }));
        } else {
            const posts = yield call(api.getPostDetail, action.payload);
            // console.log('[fetchPostDetailSaga]', posts);
            const latestPosts = yield call(api.fetchPosts, { size: 4, title: posts.data.data.title });
            const relatedPosts = yield call(api.getRelatedPosts, { type: posts.data.data.type, title: posts.data.data.title });
            yield put(actions.getPostDetail.getPostDetailSuccess({
                detail: posts.data.data,
                latest: latestPosts.data.data,
                related: relatedPosts.data.data
            }));
        }
        yield put(actions.hideLoading());
    } catch (error) {
        console.log(error);
        yield put(actions.getPostDetail.getPostDetailFailure(error));
        yield put(actions.hideLoading());
    }
}

function* createPostSaga(action) {
    try {
        yield put(actions.showLoading());
        const response = yield call(api.createPost, action.payload);
        // console.log('[createPost]', response);
        yield put(actions.createPost.createPostSuccess(response.data));
        yield put(actions.hideLoading());
        yield put(actions.globalNotification.successNotification(`success:'${action.payload.title}' is created successfully!!!`));
    } catch (error) {
        console.log(error);
        yield put(actions.createPost.createPostFailure(error));
        yield put(actions.hideLoading());
        yield put(actions.globalNotification.errorNotification(`error:${String(error)}`));
    } finally {
        yield delay(5000);
        yield put(actions.globalNotification.hideNotification());
    }
}

function* updatePostSaga(action) {
    try {
        yield put(actions.showLoading());
        const response = yield call(api.updatePost, action.payload);
        // console.log('[updatePost]', response);
        yield put(actions.updatePost.updatePostSuccess(response.data));
        yield put(actions.hideLoading());
        yield put(actions.globalNotification.successNotification(`success:'${action.payload.title}' is updated successfully!!!`));
    } catch (error) {
        console.log(error);
        yield put(actions.updatePost.updatePostFailure(error));
        yield put(actions.hideLoading());
        yield put(actions.globalNotification.errorNotification(`error:${String(error)}`));
    } finally {
        yield delay(5000);
        yield put(actions.globalNotification.hideNotification());
    }
}

function* deletePostSaga(action) {
    try {
        yield put(actions.showLoading());
        const response = yield call(api.deletePost, action.payload);
        // console.log('[updatePost]', response);
        yield put(actions.deletePost.deletePostSuccess(response.data));
        yield put(actions.hideLoading());
        yield put(actions.globalNotification.successNotification(`success:'${action.payload}' is deleted successfully!!!`));
    } catch (error) {
        console.log(error);
        yield put(actions.deletePost.deletePostFailure(error));
        yield put(actions.hideLoading());
        yield put(actions.globalNotification.errorNotification(`error:${String(error)}`));
    } finally {
        yield delay(5000);
        yield put(actions.globalNotification.hideNotification());
    }
}

function* crawlDataSaga(action) {
    try {
        yield put(actions.showLoading());
        const response = yield call(api.crawlData, action.payload);
        // console.log('[Data Crawl]', response);
        yield put(actions.crawlData.crawlDataSuccess(response.data));
        yield put(actions.hideLoading());
    } catch (error) {
        console.log(error);
        yield put(actions.crawlData.crawlDataFailure(error));
        yield put(actions.hideLoading());
    }
}

function* mySaga() {
    yield takeLatest(actions.fetchHomePageData.sendHomePageRequest, fetchHomePageDataSaga);
    yield takeLatest(actions.searchPosts.sendSearchPostsRequest, searchPostsSaga);
    yield takeLatest(actions.getLatestPosts.getPostsRequest, fetchLatestPostSaga);
    yield takeLatest(actions.getHighLightPosts.sendRequest, fetchHighLightPostsSaga);
    yield takeLatest(actions.getRelatedPosts.sendRelatedPostsRequest, fetchRelatedPostsSaga);
    yield takeLatest(actions.getPostDetail.sendPostDetailRequest, fetchPostDetailSaga);
    yield takeLatest(actions.createPost.createPostRequest, createPostSaga);
    yield takeLatest(actions.updatePost.updatePostRequest, updatePostSaga);
    yield takeLatest(actions.deletePost.deletePostRequest, deletePostSaga);
    yield takeLatest(actions.crawlData.crawlDataRequest, crawlDataSaga);
}

export default mySaga;